// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xbPqgBfulB {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.xbPqgBfulB h4 {
  line-height: 3em;
}
.xbPqgBfulB .VofjmS2NfC {
  float: left;
  width: 100%;
}
.xbPqgBfulB .KZMceIQbNH {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.xbPqgBfulB .KZMceIQbNH:hover {
  cursor: pointer;
}
.xbPqgBfulB .KZMceIQbNH:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.MBplcGwCkD .BvzrQNBLGX:focus {
  outline: none;
}
.MBplcGwCkD .BvzrQNBLGX.KSyMkstuLw.UmtGaHJ2J3 {
  background: #375A88;
}
.MBplcGwCkD .BvzrQNBLGX.KSyMkstuLw.UmtGaHJ2J3 span {
  color: #fff;
}
.MBplcGwCkD .UmtGaHJ2J3 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.MBplcGwCkD .UmtGaHJ2J3:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.MBplcGwCkD input {
  height: 38px;
  min-width: 220px;
}
.KZMceIQbNH.YjJx924lu7 {
  background: #410102;
}
.KZMceIQbNH.hULaZDpGjd {
  background: #911318;
}
.KZMceIQbNH.YgwXbKWSen {
  background: #D8293B;
}
.KZMceIQbNH.woN8VfE5tt {
  background: #F2373C;
}
.KZMceIQbNH.BcyXT_lbxJ {
  background: #FC4448;
}
.KZMceIQbNH.E6b483Tq3h {
  background: #ED535E;
}
.KZMceIQbNH.KHxziUrTu0 {
  background: #E34926;
}
.KZMceIQbNH.b5uPcf3hIm {
  background: #FC562B;
}
.KZMceIQbNH.zCFvE5m9ND {
  background: #FC6722;
}
.KZMceIQbNH.qOYukW0ww2 {
  background: #FD7F24;
}
.KZMceIQbNH.NuFVmjDcFO {
  background: #FD8D26;
}
.KZMceIQbNH.M94F5Uf6ZS {
  background: #EC9C3E;
}
.KZMceIQbNH.URt5wIczi8 {
  background: #0e673a;
}
.KZMceIQbNH.U9QxpcWtdl {
  background: #208740;
}
.KZMceIQbNH.lGile5AMCJ {
  background: #239718;
}
.KZMceIQbNH.FtHJLcpOFv {
  background: #55A84D;
}
.KZMceIQbNH.FYfI3dGKwE {
  background: #4BBE5A;
}
.KZMceIQbNH.HHkSAJB85W {
  background: #0CCA6A;
}
.KZMceIQbNH.FflxdnJYt3 {
  background: #0A3C64;
}
.KZMceIQbNH.o6byLulAhb {
  background: #0d487a;
}
.KZMceIQbNH.wJbSLFO7W_ {
  background: #10538d;
}
.KZMceIQbNH.H_3xdyC8Zd {
  background: #115A99;
}
.KZMceIQbNH.Y6BHnCrHc9 {
  background: #3387E2;
}
.KZMceIQbNH.Qj0e9vxTI9 {
  background: #1BA9CF;
}
.KZMceIQbNH.YcUIQKuh4j {
  background: #d27c02;
}
.KZMceIQbNH.Vz09miQppm {
  background: #fb9402;
}
.KZMceIQbNH.IoG4BDzBXA {
  background: #FD9B30;
}
.KZMceIQbNH.Mz1l2zI7OV {
  background: #FDBE2D;
}
.KZMceIQbNH.XeeqUUHov_ {
  background: #FED831;
}
.KZMceIQbNH.qo8FYeHHTN {
  background: #FFFD38;
}
.KZMceIQbNH.WKw1hLf49V {
  background: #2D215C;
}
.KZMceIQbNH.HKdy325sjN {
  background: #483C83;
}
.KZMceIQbNH.pE1vRmiEFi {
  background: #58518d;
}
.KZMceIQbNH.K8OdHPFLR_ {
  background: #7068A9;
}
.KZMceIQbNH.jQ4Zik8eN5 {
  background: #7f78b2;
}
.KZMceIQbNH.EML7Fc9sin {
  background: #8f88bc;
}
.KZMceIQbNH.AYy_UpAXdV {
  background: #000;
}
.KZMceIQbNH.UOaXBefKRq {
  background: #282626;
}
.KZMceIQbNH.eL8g0LbLd6 {
  background: #242222;
}
.KZMceIQbNH.QCp57gzRXE {
  background: #353838;
}
.KZMceIQbNH.qGrhefwtDp {
  background: #666;
}
.KZMceIQbNH.jNNpc0oyH_ {
  background: #999;
}
.l7V2aNHqYz {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.l7V2aNHqYz .dwgUnGFr88 {
  display: none;
}
.Q7Ez2_dFlt {
  margin: 16px 0;
}
.Q7Ez2_dFlt span {
  text-transform: capitalize;
}
.yI1hv_6W3w {
  font-size: 10px;
}
.ykOUY88Jpr.ykOUY88Jpr {
  margin-bottom: 0px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `xbPqgBfulB`,
	"color-row": `VofjmS2NfC`,
	"color-tile": `KZMceIQbNH`,
	"picker-component": `MBplcGwCkD`,
	"picker-element": `BvzrQNBLGX`,
	"active": `KSyMkstuLw`,
	"btn": `UmtGaHJ2J3`,
	"red-1": `YjJx924lu7`,
	"red-2": `hULaZDpGjd`,
	"red-3": `YgwXbKWSen`,
	"red-4": `woN8VfE5tt`,
	"red-5": `BcyXT_lbxJ`,
	"red-6": `E6b483Tq3h`,
	"orange-1": `KHxziUrTu0`,
	"orange-2": `b5uPcf3hIm`,
	"orange-3": `zCFvE5m9ND`,
	"orange-4": `qOYukW0ww2`,
	"orange-5": `NuFVmjDcFO`,
	"orange-6": `M94F5Uf6ZS`,
	"green-1": `URt5wIczi8`,
	"green-2": `U9QxpcWtdl`,
	"green-3": `lGile5AMCJ`,
	"green-4": `FtHJLcpOFv`,
	"green-5": `FYfI3dGKwE`,
	"green-6": `HHkSAJB85W`,
	"blue-1": `FflxdnJYt3`,
	"blue-2": `o6byLulAhb`,
	"blue-3": `wJbSLFO7W_`,
	"blue-4": `H_3xdyC8Zd`,
	"blue-5": `Y6BHnCrHc9`,
	"blue-6": `Qj0e9vxTI9`,
	"yellow-1": `YcUIQKuh4j`,
	"yellow-2": `Vz09miQppm`,
	"yellow-3": `IoG4BDzBXA`,
	"yellow-4": `Mz1l2zI7OV`,
	"yellow-5": `XeeqUUHov_`,
	"yellow-6": `qo8FYeHHTN`,
	"purple-1": `WKw1hLf49V`,
	"purple-2": `HKdy325sjN`,
	"purple-3": `pE1vRmiEFi`,
	"purple-4": `K8OdHPFLR_`,
	"purple-5": `jQ4Zik8eN5`,
	"purple-6": `EML7Fc9sin`,
	"black-1": `AYy_UpAXdV`,
	"black-2": `UOaXBefKRq`,
	"black-3": `eL8g0LbLd6`,
	"black-4": `QCp57gzRXE`,
	"black-5": `qGrhefwtDp`,
	"black-6": `jNNpc0oyH_`,
	"picker-theme": `l7V2aNHqYz`,
	"arrow-regular": `dwgUnGFr88`,
	"select-option__root": `Q7Ez2_dFlt`,
	"input__label": `yI1hv_6W3w`,
	"input-base__root": `ykOUY88Jpr`
};
export default ___CSS_LOADER_EXPORT___;
